import './Video.scss';
import ReactPlayer from 'react-player/lazy';
import React from 'react';
import { Typography } from '@mui/material';

export type VideoProps = {
  url: string;
  title: string;
};

const Video: React.FC<VideoProps> = ({ url, title }: VideoProps) => {  
  return (
    
    <div className='video'>
      <ReactPlayer 
        width='100%' 
        height='100%' 
        className='react-player'
        url={url}
        controls={true}
      />
      <Typography variant='body2' component='small'>{title}</Typography>
    </div>
  );
};

export default Video;
